import { createAsyncThunk } from '@reduxjs/toolkit';
import { EmprestimoService } from '../../common/services/emprestimo';

export const getContratos = createAsyncThunk(
  'loan/getContratos',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const { matricula, token } = state.user.data;

      const contratosEmprestimosServices = new EmprestimoService();

      const response = await contratosEmprestimosServices.obterContratos({
        matricula,
        token,
      });

      const {
        contratos = [],
        totalParcelasEmAtraso,
        valorTotalEmAtraso,
        valorTotalSaldoDevedor,
      } = response.data;

      const contratosFormatado = contratos.map((contrato) => ({
        ...contrato,
        parcelas: contrato.parcelas.map((parc) => ({
          ...parc,
          data: parc.data.split('/').reverse().join('/'),
        })),
      }));

      return {
        listagemContratos: contratosFormatado,
        informacoesGerais: {
          totalParcelasEmAtraso,
          valorTotalEmAtraso,
          valorTotalSaldoDevedor,
        },
      };
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);

export const getLimite = createAsyncThunk(
  'loan/getLimite',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const { matricula, token } = state.user.data;

      const limiteEmprestimoService = new EmprestimoService();

      const response = await limiteEmprestimoService.obterLimiteEmprestimo({
        matricula,
        token,
      });

      const limite = {
        total: parseFloat(response.E_LIM_MAX, 10),
        limiteMinimo: parseFloat(response.E_LIM_MIN, 10),
        novoContratoBloqueado:
          response.E_INADIM === 'S' || response.E_CARENCIA === 'S',
        saldoDevedor: parseFloat(response.T_SLDDEV, 10),
        quantidadeMaximaParcelas: parseInt(response.E_PRAZO_MAX_REAL, 10),
        taxa: parseFloat(response.E_TXJRS_AA, 10),
        taxaMes: parseFloat(response.E_TXJRS_AM, 10),
        taxaFundo: parseFloat(response.E_TXSEG_AM, 10),
        msgErro: response.ERRO_SHAREPOINT,
        msgBloqueio: response.T_BLOQUEIO,
      };

      return limite;
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);

export const getAssinaturaPendente = createAsyncThunk(
  'loan/getAssinaturaPendente',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { matricula } = getState().user.data;
      const assinaturaEmprestimosServices = new EmprestimoService();

      const response =
        await assinaturaEmprestimosServices.obterAssinaturasPendentesEmprestimo(
          matricula
        );

      const assinaturaPendente = {
        pendente: !!response.linkassinatura,
        valor: response.valor,
        link: response.linkassinatura,
      };

      return assinaturaPendente;
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);

export const getSolicitacao = createAsyncThunk(
  'loan/getSolicitacao',
  async ({ valor, parcelas }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const { matricula, token } = state.user.data;

      const simulacaoEmprestimoService = new EmprestimoService();

      const emprestimo =
        await simulacaoEmprestimoService.obterValoresEmprestimoInicial({
          matricula,
          token,
          valor,
          parcelas,
        });

      const payload = {
        matrizOpcoesParcelas: emprestimo.T_SIMPARC[0].item.reverse(),
        dataPrimeiraParcela: emprestimo.E_DT_PRIM_PREST[0],
        parcelaMinCalculada: Number(emprestimo.T_SIMPARC[0].item[0].PRAZO[0]),
        valorLiberado: Number(emprestimo.E_VLRLIQ[0]),
        valorParcelas: Number(emprestimo.T_SIMPARC[0].item[0].VLR_PARC[0]),
        dataPrevistaCredito: emprestimo.E_DT_DESEMB[0],
      };

      return payload;
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);
